module.exports = __webpack_public_path__ + "img/dsb-logo.2014_pos_rgb-copy.ad43d9b6.png";